<div class="select-question">
  <div class="select-question__label">
    <ion-label>{{question.label}}</ion-label>
  </div>

  <select placeholder="Select an option" type="select" class="select-question__select" [name]="question.key"
          [(ngModel)]="question.editingValue" (change)="onChange()" (cdkAutofill)="onChange()" required
          #control="ngModel">
    <option selected disabled value="">- Select Date -</option>
    <option *ngFor="let opt of options$ | async" class="select-question__select__option" [value]="opt.Value">
      {{opt.Label}}
    </option>
  </select>
</div>
